import dayjs from "dayjs";
import type { IProviderOverrideListWithDates } from './components/AddOverrideModal/types';
import { IproviderOverrideList } from "types/appointmentSetting";

export const getOverrideDate = (item: IProviderOverrideListWithDates) => {
    const dayjsDates = item.overrideDates.map(({ date }) => {
        return dayjs(date);
    });
    if (dayjsDates.length === 1) {
        return dayjsDates[0].format('MMMM D, YYYY');
    }

    dayjsDates.sort((a, b) => a.valueOf() - b.valueOf());

    // 分组连续日期
    const groups: dayjs.Dayjs[][] = [];
    let currentGroup: dayjs.Dayjs[] = [dayjsDates[0]];

    for (let i = 1; i < item.overrideDates.length; i++) {
        const currentDate = dayjsDates[i];
        const prevDate = dayjsDates[i - 1];

        // 检查当前日期是否与前一个日期相差一天
        if (currentDate.diff(prevDate, 'day') === 1) {
            currentGroup.push(currentDate);
        } else {
            groups.push([...currentGroup]);
            currentGroup = [currentDate];
        }
    }
    groups.push(currentGroup);

    const formattedGroups = groups.map((group) => {
        if (group.length === 1) {
            // 单个日期
            return group[0].format('MMMM D, YYYY');
        } else {
            // 连续日期
            const firstDate = group[0];
            const lastDate = group[group.length - 1];

            // 检查年份和月份是否相同
            if (firstDate.year() === lastDate.year()) {
                if (firstDate.month() === lastDate.month()) {
                    // 同年同月
                    return `${firstDate.format('MMMM')} ${firstDate.date()} - ${lastDate.date()}, ${firstDate.year()}`;
                } else {
                    // 同年不同月
                    return `${firstDate.format('MMMM')} ${firstDate.date()} - ${lastDate.format('MMMM')} ${lastDate.date()}, ${firstDate.year()}`;
                }
            } else {
                // 不同年
                return `${firstDate.format('MMMM D, YYYY')} - ${lastDate.format('MMMM D, YYYY')}`;
            }
        }
    });

    return formattedGroups;
};

export const transferTimePicker = (val) => {
    const { fromHour, fromMinute, toHour, toMinute } = val;
    // eslint-disable-next-line no-nested-ternary
    const startHour = `${fromHour < 10 ? `0${fromHour}` : (fromHour > 12 ? ((fromHour === 23 || fromHour === 22) ? fromHour - 12 : `0${fromHour - 12}`) : fromHour)}`;
    const startMinute = `${fromMinute < 10 ? `0${fromMinute}` : fromMinute}`;
    const startLabel = `${startHour}:${startMinute} ${fromHour >= 12 ? 'PM' : 'AM'}`;

    // eslint-disable-next-line no-nested-ternary
    const endHour = `${toHour < 10 ? `0${toHour}` : (toHour > 12 ? ((toHour === 23 || toHour === 22) ? toHour - 12 : `0${toHour - 12}`) : toHour)}`;
    const endMinute = `${toMinute < 10 ? `0${toMinute}` : toMinute}`;
    const endLabel = `${endHour}:${endMinute} ${toHour >= 12 ? 'PM' : 'AM'}`;
    return `${startLabel}-${endLabel}`;
};

export const mergeOverrideList = (data: IproviderOverrideList[]): IProviderOverrideListWithDates[] => {
    const map = new Map();

    data.forEach(({ time, overrideDate, id }) => {
        const key = JSON.stringify(time);

        if (map.has(key)) {
            map.get(key).overrideDates.push({
                date: overrideDate,
                id,
            });
        } else {
            map.set(key, { time, overrideDates: [{ date: overrideDate, id }] });
        }
    });

    return Array.from(map.values());
}